import { observer } from "mobx-react-lite";
import React from "react";
import { CustomPasswordInput, CustomFormControl, CustomInput } from "@lubbezposrednio-frontend/commons";
import { bindProperty, PASSWORD_TOOLTIP, AuthorizationModel } from "@lubbezposrednio-frontend/core";
import { FiMail, FiLock } from "react-icons/fi";

interface RegisterFormProps {
  authorization: AuthorizationModel;
}

export const RegisterForm: React.FC<RegisterFormProps> = observer(({ authorization }) => {
  const inputIds = {
    email: "email",
    password: "password",
    confirmPassword: "confirm-password"
  };

  return (
    <>
      <CustomFormControl
        id={inputIds.email}
        isInvalid={authorization.getIsTouched(inputIds.email) && !authorization.isEmailCorrect}
        errorMessage="Podany adres e-mail jest niepoprawny."
        w="100%"
        labelTitle="Email"
      >
        <CustomInput
          autoComplete="email"
          leftIcon={FiMail}
          placeholder="twoj@email.pl"
          {...bindProperty(authorization, "email")}
          onFocus={() => {
            authorization.setIsTouched(inputIds.email);
          }}
        />
      </CustomFormControl>
      <CustomFormControl
        id={inputIds.password}
        isInvalid={authorization.getIsTouched(inputIds.password) && !authorization.isPasswordCorrect}
        errorMessage={PASSWORD_TOOLTIP}
        tooltipMessage={PASSWORD_TOOLTIP}
        onFocus={() => {
          authorization.setIsTouched(inputIds.password);
        }}
        w="100%"
        labelTitle="Hasło"
      >
        <CustomPasswordInput leftIcon={FiLock} placeholder="Min. 8 znaków" {...bindProperty(authorization, "password")} />
      </CustomFormControl>
      <CustomFormControl
        id={inputIds.confirmPassword}
        isInvalid={authorization.getIsTouched(inputIds.confirmPassword) && !authorization.arePasswordsTheSame}
        errorMessage="Hasła nie są identyczne"
        onFocus={() => {
          authorization.setIsTouched(inputIds.confirmPassword);
        }}
        w="100%"
        labelTitle="Powtórz hasło"
      >
        <CustomPasswordInput leftIcon={FiLock} placeholder="Powtórz hasło" {...bindProperty(authorization, "confirmPassword")} />
      </CustomFormControl>
    </>
  );
});
